var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.pA=require("moment");module.exports=$CLJS.pA;